<template>
	<div class="operationPersonerManage mainBox">
		<div class="mainTop disBetween">
			<div class="titleIcon"></div>
			<div class="titleName">运维提现管理</div>
		</div>
		<div class="mainBot ">
			<div class="itemTitleBox disBetween">
				<div class="disStart">
					<span class="title">运维提现列表</span>
				</div>
				<!-- <div class="icon_add iconBox" @click="itemClick({},5)" title="新增运维人员"></div> -->
			</div>
			<div class="BtnBox disBetween">
				<div class="searchBox disBetween">
					<div class="disBetween searchLeft">
						<div class="myinputBox">
							<el-input clearable v-model="searchObj.repairUserName" placeholder="请输入人员名称">
							</el-input>
						</div>
						<div class="myinputBox myinputBox5">
							<el-date-picker  v-model="searchObj.startTime" value-format="yyyy-MM-dd" type="date"
								placeholder="开始时间">
							</el-date-picker>
						</div>
						<div class="myinputBox myinputBox5">
							<el-date-picker v-model="searchObj.endTime" value-format="yyyy-MM-dd" type="date"
								placeholder="结束时间">
							</el-date-picker>	
							<!-- <el-date-picker v-model="searchObj.searchData" type="daterange" range-separator="~"
								value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期">
							</el-date-picker> -->
						</div>
						<el-button type="success" @click="toSearch">查询</el-button>
					</div>
				</div>
			</div>
			<div class="listBox">
				<div style="height: 100%;width: 100%;" v-loading="loading">
					<div class="content myTable">
						<el-table :data="tableData" stripe style="width: 100%">
							<el-table-column type="index" label="序号">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="repairUserId" label="人员编号">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="repairUserName" label="人员名称">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="withdrawalAmount" label="提现金额">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="withdrawalTime" label="提现时间">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="withdrawalReason" label="提现理由">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="withdrawalFlag" label="审核状态">
								<template slot-scope="scope">
									<span>{{scope.row.withdrawalFlag==1?"审核中":scope.row.withdrawalFlag==2?"审核通过":'审核不通过'}}</span>
								</template>
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="auditReason" label="审核内容">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="approvalTime" label="审核时间">
							</el-table-column>
							<el-table-column label="操作" width="150">
								<template slot-scope="scope">
									<el-button v-if="scope.row.withdrawalFlag==1" type="text" size="small"
										@click="itemClick(scope.row,1)">审核</el-button>
									<el-button v-if="scope.row.withdrawalFlag!=1" type="text" size="small"
										@click="itemClick(scope.row,1)">查看</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="pagination  mypagination">
						<el-pagination background small :page-size="PageInfo.pagesize" :current-page="PageInfo.pagenum"
							:total="PageInfo.total" :pager-count="5" prev-text="上一页" next-text="下一页"
							layout="total, prev, pager, next,jumper" ref="pagination"
							@current-change="handleCurrentChange">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
		<el-dialog title="提现信息" center class="mydialog" :visible.sync="dialogVisible" width="60%">
			<div class="dialogBox3">
				<div class="titleBox">运维人员信息</div>
				<div class="contBox">
					<div class="itemBox  disStart">
						<div class="elBox ">
							<span class="nameBox">人员名称:</span>
							<span class="valueBox">{{creatObj.repairUserName}}</span>
						</div>
						<div class="elBox">
							<span class="nameBox">人员编号:</span>
							<span class="valueBox">{{creatObj.repairUserId}}</span>
						</div>
					</div>
					<div class="itemBox  disStart">
						<div class="elBox ">
							<span class="nameBox">提现金额:</span>
							<span class="valueBox">{{creatObj.withdrawalAmount}}元</span>
						</div>
						<div class="elBox ">
							<span class="nameBox">提现申请时间:</span>
							<span class="valueBox">
								{{creatObj.withdrawalTime}}
							</span>
						</div>
					</div>
				</div>
				<div class="titleBox">审核信息</div>
				<el-form :model="creatObj" :rules="rules" ref="ruleForm1" label-width="100px" class="demo-ruleForm"
					v-if="creatObj.withdrawalFlag==1">
					<div class="diaItem diaItem2">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="审核结果:" prop="check">
								<div class="myinputBox4">
									<el-radio-group v-model="creatObj.check">
										<el-radio :label="2">通过</el-radio>
										<el-radio :label="3">不通过</el-radio>
									</el-radio-group>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem diaItem2" v-if="creatObj.check==3">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="审核内容:" prop="auditReason">
								<div class="myinputBox4">
									<el-input clearable v-model="creatObj.auditReason" placeholder="请输入审核内容">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
				</el-form>
				<div class="contBox" v-else>
					<div class="itemBox  disStart">
						<div class="elBox elBox2">
							<span class="nameBox">审核结果:</span>
							<span
								class="valueBox">{{creatObj.withdrawalFlag==2?"通过":creatObj.withdrawalFlag==3?"不通过":""}}</span>
						</div>
					</div>
					<div class="itemBox  disStart">
						<div class="elBox elBox2">
							<span class="nameBox">审核内容:</span>
							<span class="valueBox">{{creatObj.auditReason}}</span>
						</div>
					</div>
				</div>
			</div>
			<div slot="footer" class="diabtnBox" v-if="creatObj.withdrawalFlag==1">
				<el-button @click="dialogVisible = false">取消</el-button>
				<el-button type="primary" @click="toSave('ruleForm1')">确定</el-button>
			</div>
			<div slot="footer" class="diabtnBox" v-else>
				<el-button type="primary" @click="dialogVisible = false">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	import {
		timestampToDate
	} from "../../../../assets/js/common.js"
	export default {
		name: "operationPersonerManage",
		components: {},
		data() {
			let that = this;
			return {
				PageInfo: {
					pagesize: 10,
					pagenum: 1,
					total: 0
				},
				creatObj: {
					repairUserName: "", //人员名称
					repairUserId: "", //人员工号
					repairUserPhone: "", //联系电话
					repairUserType: "", //人员级别
					manageProvinceNo: "", //管辖省
					manageCityNo: "", //管辖市
					manageAreaNo: "", //管辖区
					repairUserStatus: "", //人员状态 1正常 2停工
					provinceNo: "", //家庭住址省
					cityNo: "", //运维人员
					areaNo: "", //家庭住址区
					address: "", //家庭住址详细地址
					communityIdList: [],
					flag: []
				},
				dialogVisible: false,
				NOfalse: false,
				statusList: [{
						text: "通过",
						value: 2
					},
					{
						text: "不通过",
						value: 3
					}
				],
				tableData: [],
				loading: false,
				searchObj: {
					pageNo: 1, //当前页
					pageSize: 10, //当前页个数
					repairUserName: "",
					startTime: "",
					endTime: "",
					searchData: [],
				},
				rules: {
					check: [{
						required: true,
						message: '请选择审核结果',
						trigger: 'change'
					}],
					auditReason: [{
						required: true,
						message: '请输入审核内容',
						trigger: 'blur'
					}],
				},
			}
		},
		mounted() {
			// let time = new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000
			// this.searchObj.searchData = [timestampToDate(time), timestampToDate(new Date().getTime())]
			this.$nextTick(() => {
				this.getData()
			})
		},
		methods: {
			// 保存按钮点击事件 新建/编辑
			toSave(formName) {
				let that = this
				this.$refs[formName].validate((valid) => {
					if (valid) {
						let obj = {
							withdrawalId: that.creatObj.withdrawalId,
							withdrawalFlag: that.creatObj.check,
							auditReason: that.creatObj.check == 3 ? that.creatObj.auditReason : "",
						}
						console.log(obj)
						that.$api.checkWithdraw(obj).then((res) => {
							if (res.returnCode == 200) {
								that.$message({
									type: 'success',
									message: '审核成功!'
								});
								setTimeout(() => {
									that.getData()
								}, 500)
								this.dialogVisible = false
							}
						})

					} else {
						return false;
					}
				});

			},
			// 审核
			itemClick(item, n) {
				let that = this
				this.$set(this, "creatObj", item)
				this.dialogVisible = true
				if (n == 1) {
					this.$nextTick(() => {
						if(that.$refs.ruleForm1){
							that.$refs.ruleForm1.clearValidate()
						}
					})
				}
			},
			getName(val, arr) {
				let obj = arr.find((item) => {
					return val == item.value
				})
				return obj.text
			},
			toSearch() {
				this.$set(this.PageInfo,"pagenum",1)
				this.$set(this.searchObj,"pageNo",1)
				this.getData()
			},
			getData(n) {
				this.loading = true
				this.$api.listWithdrawRecord(this.searchObj).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "tableData", res.obj.list)
						this.$set(this.PageInfo, "total", res.obj.total || 0)
						this.loading = false
					}
				})
			},
			// 选择分页
			handleCurrentChange(val) {
				this.$set(this.PageInfo,"pagenum",val)
				this.$set(this.searchObj,"pageNo",val)
				this.getData({})
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "./operationWithdrawal.scss";
</style>